// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import Modal from '../Modal';

export default class PublicPassword extends Modal {

    state = {
        email: "",
        password: "",
        alert: {
            email: false,
            password: false
        }
    }

    componentDidMount = () => {
        if (this.props.data)
            this.setState({ email: this.props.data });
    }

    alert = async (field) => {
        await this.setState({ alert: {
            ...this.state.alert,
            [field]: false
        } });
        return setTimeout(() => this.setState({ alert: {
            ...this.state.alert,
            [field]: true
        } }), 50);
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <br /><br />

            <h1>This file is protected!</h1>

            <p style={{ width: 375, margin: '0 auto' }}>
                The owner of this document has locked it with a password. If you don't have the password, please contact the person who shared this with you.
            </p>

            <br /><br />

            <form
                onSubmit={async (e) => {

                    e.preventDefault();
                    e.stopPropagation();

                    const { email, password } = this.state;

                    if (!email || email === "" || !email.includes("@"))
                        return this.alert("email");

                    if (!password || password === "" || password.length < 6)
                        return this.alert("password");

                    // Set account info as Auth to refetch document
                    await this.setState({ password: "" });
                    await this.props.setCredentials(email, password);
                }}
            >

                <label className="modal-label">Email</label>

                <input
                    id="email"
                    name="email"
                    type="text"
                    className={this.state.alert.email ? "input-error" : ""}
                    placeholder="Enter email address..."
                    style={{ width: 330 }}
                    value={this.state.email}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ email: e.target.value, alert: {
                        ...this.state.alert,
                        email: false
                    } })}
                />

                <label className="modal-label">Password</label>

                <input
                    id="password"
                    name="password"
                    type="password"
                    className={this.state.alert.password ? "input-error" : ""}
                    placeholder="Enter the password..."
                    style={{ width: 330 }}
                    value={this.state.password}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ password: e.target.value, alert: {
                        ...this.state.alert,
                        password: false
                    } })}
                />

                <br />

                <input
                    type="submit"
                    value="Validate"
                    style={{
                        float: 'none'
                    }}
                />
            
            </form>
            
        </div>);
    }

};